import React from 'react'
import SubHeader from '../general/SubHeader';
import Billing1 from '../assets/product/billing1.webp';
import Billing2 from '../assets/product/billing2.webp';

const BillingSoftware = () => {
    return (
        <>
            <SubHeader message='Billing Software' />

            <section className='my-5'>
                <div className='container'>

                    <div className='row'>

                        <div className='col-lg-8 col-12'>
                            <img src={Billing2} className='img-fluid' alt='Billing Software' />
                            <p className='sec-heading'>Dectwin Billing Software</p>
                            <p className='text-muted'>Being the Best billing software providers in Prayagraj we have simplified billing and invoicing for businesses. Our Dectwin billing software for Android is
                                equipped with advanced features like automated invoicing, gst tax calculations, multiple counter billing and inventory management.</p>

                                <div className='bg-light rounded-3 px-3 py-3 my-3'>
                            <p className='banner-subheading'>Windows/ Android Billing Software in Allahabad</p>
                            <p className='text-muted'>Our Billing software development company in Prayagraj has developed POS Billing Software in India   to simplify financial management. With features
                                like automated invoicing, payment tracking, and real-time reporting, this hotel/ restaurant billing software for windows
                                can streamline the billing process. It also supports multiple payment methods and provides detailed insights into financial
                                performance, ensuring efficiency and accuracy. This system helps reduce manual errors and saves time by automating routine tasks.
                            </p>
                            </div>

                            <div className='bg-light rounded-3 px-3 py-3'>
                                <p className='banner-subheading'>Features of Dectwin Billing Software</p>
                                <p className='text-muted'><strong>Real time Inventory tracking:</strong> This allows users to add, update, and track their inventory items with ease. The system includes detailed item descriptions and stock levels, with automated alerts for low stock, ensuring businesses never run out of essential products.<br /><br />
                                    <strong>Sale Invoice:</strong> This lets users generate professional invoices with customizable templates, including options for tax rates and discounts. The Sale History section keeps a comprehensive record of all past sales transactions, making it easy with our billing software for retail shop & others to search for specific invoices and analyze sales trends.<br /><br />
                                    <strong>Purchase Invoice:</strong> The app also excels in managing Purchase Invoices. Users can create purchase invoices for their suppliers, maintaining accurate records of all procurement activities. The Purchase History feature tracks all supplier transactions and outstanding payments, facilitating efficient supply chain management.<br /><br />
                                    <strong>Multi-payment method:</strong> It supports for generating quotes, the Estimate Invoice feature allows users to create detailed estimates for potential clients, which can later be converted into sale invoices. This ensures a seamless sales process, with the Estimate History section allowing users to review, edit, and follow up on previous quotes.</p>

                            </div>

                        </div>

                        <div className='col-lg-4 col-12 my-2'>
                                                        <div className='bg-light px-3 py-4 rounded-3 mb-3'>
                                <p className='fw-bold fs-5'>Get Demo of Dectwin Billing Software</p>
                                <button className='banner-btn1' onClick={() => window.open('https://wa.me/8707510135?text=Hey!%20Dectwin%20Services.%20I%20want%20demo%20of%20Dectwin%20Billing%20Software.', '_blank')}>Click to Get Free DEMO</button>
                                </div>

                            <div className='bg-light px-3 py-4 rounded-3'>
                                <p className='fw-bold fs-5'>Product Information</p>

                                <div className='contact-area mb-3'>
                                    <i class="fa-solid contact-icon fa-cash-register"></i>
                                    <div>
                                        <p className='fw-semibold my-0'>Multiple Counter Billing</p>
                                        <p className='para-text text-muted'>Manage multiple counters for faster billing, reduce customer waiting time</p>
                                    </div>
                                </div>

                                <div className='contact-area mb-3'>
                                    <i class="fa-solid contact-icon fa-barcode"></i>
                                    <div>
                                        <p className='fw-semibold my-0'>Bar Code Generation</p>
                                        <p className='para-text text-muted'>Generate barcodes instantly to streamline inventory and product management</p>
                                    </div>
                                </div>

                                <div className='contact-area mb-3'>
                                    <i class="fa-solid contact-icon fa-network-wired"></i>
                                    <div>
                                        <p className='fw-semibold my-0'>Multiple Business Management</p>
                                        <p className='para-text text-muted'>Billing for all your firms without switching between systems</p>
                                    </div>
                                </div>

                                <div className='contact-area mb-3'>
                                    <i class="fa-solid contact-icon fa-rectangle-list"></i>
                                    <div>
                                        <p className='fw-semibold my-0'>Inventory, Sales & Purchase Report</p>
                                        <p className='para-text text-muted'>Gain valuable insights into your business performance, identify trends, and make data-driven decisions</p>
                                    </div>
                                </div>

                                <div className='contact-area mb-3'>
                                    <i class="fa-solid contact-icon fa-qrcode"></i>
                                    <div>
                                        <p className='fw-semibold my-0'>QR Code Generation</p>
                                        <p className='para-text text-muted'>Enable fast, secure digital payments and enhances your business's modern appeal</p>
                                    </div>
                                </div>

                                <img src={Billing1} className='img-fluid mt-3' alt='Billing Software' />
                            </div>

                        </div>
                        {/* right ends */}

                    </div>
                    {/* row ends */}

                </div>
            </section>


{/* Pricing Section */}
<section className='my-5'>
  <div className='container text-center'>

  <div className='sec-heading text-capitalize'>Plans & Pricing</div>

<div className='row mt-4 justify-content-center'>

<div className='my-2 col-lg-4 col-md-6 col-12'>

<div className='pricing-outer'>
<div className='pricing-inner'>
  <h5 className='text-uppercase'>Basic Plan</h5>
  <div className='sec-heading'>₹ 4999/- Year</div>
  <h5 className='mt-3'><span className='text-red'><i class="fa-solid fa-tags fa-flip-horizontal"></i> Sale</span> <span className='text-decoration-line-through'>₹ 7,999</span><br />
   Yearly AMC 3,999/-</h5>
</div>

<div className='bg-light px-4 py-4 text-muted'>
  <h6>Android, Desktop</h6>
  <hr />
  <h6>Manage Bulk Stock/ Inventory</h6>
  <hr />
  <h6>Generate & Print Barcode</h6>
  <hr />
  <h6>Multiple Counter Billing</h6>
  <hr />
  <h6>Sales & Purchase</h6>
  <hr />
  <h6>QR Code Generation</h6>
  <hr />
  <h6>Touch Enabled POS</h6>
</div>

</div>
{/* pricing outer ends */}
</div>
{/* column ends */}

<div className='my-2 col-lg-4 col-md-6 col-12'>

<div className='pricing-outer'>
<div className='pricing-inner'>
  <h5 className='text-uppercase'>Premium Plan</h5>
  <div className='sec-heading'>₹ 9999/- Year</div>
  <h5 className='mt-3'><span className='text-red'><i class="fa-solid fa-tags fa-flip-horizontal"></i> Sale</span> <span className='text-decoration-line-through'>₹ 15,999</span><br />
  Yearly AMC 3,999/-</h5>
</div>

<div className='bg-light px-4 py-4 text-muted'>
  <h6>Annual Software Maintenance</h6>
  <hr />
  <h6>Regular Updates</h6>
  <hr />
  <h6>1 Year Plan Recharge</h6>
  <hr />
  <h6>Technical Support</h6>
  <hr />
  <h6>Online Assistance</h6>
  <hr />
  <h6>Minor Customizations</h6>
</div>

</div>
{/* pricing outer ends */}
</div>
{/* column ends */}

</div>
{/* row ends */}

  </div>
</section>
{/* Pricing Section ends */}

        </>
    )
}

export default BillingSoftware
